import React from 'react';

export const RightDesignPanel = () => {
  return (
    <div className="w-full lg:w-[48%] p-8 sm:p-12 lg:p-14 flex flex-col justify-between relative overflow-hidden text-white min-h-[400px] lg:min-h-auto">
      {/* Real premium modular kitchen background photo */}
      <img
        src={require('../../../assets/Images/13.jpg')}
        alt="SD Modular Kitchen"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      {/* Dark luxury overlay wash for excellent text legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/50 to-transparent" />

      {/* Top subtle decorative pattern */}
      <div className="absolute top-0 left-0 right-0 h-40 bg-gradient-to-b from-black/25 to-transparent pointer-events-none" />

      {/* Spacer to push text content down to bottom */}
      <div className="flex-1" />

      {/* Text Content at the bottom, perfectly clean and luxurious */}
      <div className="relative z-10 text-center lg:text-left mt-auto">
        <span className="text-[10px] font-bold tracking-[0.3em] text-[#b5966a] uppercase block mb-2">Space Designs</span>
        <h2 className="font-serif text-3xl font-medium tracking-wide mb-3 leading-tight text-white">
          Premium uPVC &<br />WPVC Frames
        </h2>
        <p className="text-white/80 text-xs leading-relaxed max-w-[280px] mx-auto lg:mx-0 font-light">
          End-to-end management for uPVC & WPVC doors, windows, and frame solutions — from lead to installation tracking.
        </p>
      </div>

      {/* Indicator Dots at bottom */}
      <div className="flex justify-center items-center gap-2 mt-8 relative z-10">
        <span className="w-6 h-1.5 rounded-full bg-[#b5966a] transition-all duration-300" />
        <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
        <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
        <span className="w-1.5 h-1.5 rounded-full bg-white/40" />
      </div>
    </div>
  );
};




